import script from "./SfxMainMenuManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxMainMenuManager.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QRouteTab from 'quasar/src/components/tabs/QRouteTab.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QTab,QMenu,QRouteTab});qInstall(script, 'directives', {Ripple});
